var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            { staticClass: "mr-2" },
            [_c("DateRangePicker", { ref: "selectedRange" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mr-2" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedDivision,
                    expression: "selectedDivision",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedDivision = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "0" } }, [
                  _vm._v("Все дивизионы"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.$AllDivisions, function (div) {
                  return _c("option", { domProps: { value: div.id } }, [
                    _vm._v(_vm._s(div.title)),
                  ])
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  loading: _vm.loading,
                  onClick: () => _vm.showReport(),
                  color: _vm.$constants.PRIMARY_COLOR,
                  className: "btn btn-outline-info",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records && !_vm.loading
            ? [
                _c("table", { staticClass: "table table-hover table-sm" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.records, function (r) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(_vm._s(_vm.printDate(r.date, "DD.MM.YYYY"))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.$AllDivisions[r.division_id].title)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(r.data.balance.start, function (b, curr) {
                            return b.orders
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$AllCurrencies[curr].currency) +
                                      ":\n                "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(b.orders.toLocaleString("ru-RU"))
                                    ),
                                  ]),
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                        _c(
                          "td",
                          _vm._l(r.data.balance.end, function (b, curr) {
                            return b.orders
                              ? _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$AllCurrencies[curr].currency) +
                                      ":\n                "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(b.orders.toLocaleString("ru-RU"))
                                    ),
                                  ]),
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _vm._v("Заявки: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  r.data.orders.total_price.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("ЗП: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  r.data.orders.total_salary.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("ПР: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  r.data.orders.total_post.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Сдать: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  r.data.orders.total_pass_wo_salary.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Себестоимость: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  r.data.orders.total_cost.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            r.data.expenses && r.data.expenses.length
                              ? [
                                  _c("p", [_vm._v("Расходы")]),
                                  _vm._v(" "),
                                  _vm._l(r.data.expenses, function (e) {
                                    return _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllCurrencies[e.currency_id]
                                            .currency
                                        ) + ":\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(e.sum.toLocaleString("ru-RU"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      e.comment
                                        ? _c("span", [
                                            _vm._v(
                                              "(" + _vm._s(e.comment) + ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            (r.data.incomes.in && r.data.incomes.in.length) ||
                            (r.data.incomes.out && r.data.incomes.out.length)
                              ? [
                                  _c("p", [_vm._v("Инкассации")]),
                                  _vm._v(" "),
                                  _vm._l(r.data.incomes.in, function (e) {
                                    return _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllCurrencies[e.currency_id]
                                            .currency
                                        ) + ":\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "+" +
                                            _vm._s(
                                              e.sum.toLocaleString("ru-RU")
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      e.comment
                                        ? _c("span", [
                                            _vm._v(
                                              "(" + _vm._s(e.comment) + ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _vm._l(r.data.incomes.out, function (e) {
                                    return _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllCurrencies[e.currency_id]
                                            .currency
                                        ) + ":\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              e.sum.toLocaleString("ru-RU")
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      e.comment
                                        ? _c("span", [
                                            _vm._v(
                                              "(" + _vm._s(e.comment) + ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            r.data.exchanges && r.data.exchanges.length
                              ? [
                                  _c("p", [_vm._v("Покупка")]),
                                  _vm._v(" "),
                                  _vm._l(r.data.exchanges, function (e) {
                                    return _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllCurrencies[e.currency_id]
                                            .currency
                                        ) + ":\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(e.sum.toLocaleString("ru-RU"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              Math.round((1 / e.rate) * 100) /
                                                100
                                            ) +
                                            ")"
                                        ),
                                      ]),
                                    ])
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.records && !_vm.loading
            ? [_vm._v("\n        Выберите дату\n      ")]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Начало")]),
        _vm._v(" "),
        _c("th", [_vm._v("Конец")]),
        _vm._v(" "),
        _c("th", [_vm._v("Детали")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }